export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL;

export const setApiBaseUrl = (url) => {
  API_BASE_URL = url;
};
